/* eslint-disable no-restricted-globals */
import type { SyntheticEvent } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getErrorTranslationKey } from 'utils'

import AutorenewIcon from '@mui/icons-material/Autorenew'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import type { AlertColor } from '@mui/material/Alert'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Link from '@mui/material/Link'

import useStyles from './useStyles'

export interface CommonAlertProps {
  errorCode?: number | null
  onRefresh?: () => void
  padding?: string
  severity?: AlertColor
  showRefreshPage?: boolean
}

const iconMapping = {
  error: <WarningAmberIcon fontSize="inherit" />,
}

export function CommonAlert({
  errorCode,
  onRefresh,
  padding = '1rem',
  severity = 'error',
  showRefreshPage = false,
}: CommonAlertProps) {
  const classes = useStyles({ padding })
  const { t: translate } = useTranslation()
  const onClick = (event: SyntheticEvent) => {
    event.preventDefault()
    onRefresh?.()
  }
  const alertClasses = {
    icon: classes.icon,
    message: classes.message,
    root: classes.root,
  }
  const reloadApp = () => {
    location.reload()
    location.replace('/')
  }

  return (
    <Alert classes={alertClasses} iconMapping={iconMapping} severity={severity}>
      <Box alignItems="center" display="flex" maxHeight="1rem">
        <Box className={classes.text}>
          {translate(`alert.${getErrorTranslationKey(errorCode)}`)}
          {showRefreshPage && (
            <>
              {', '}
              <Link color="inherit" href="#" onClick={reloadApp} underline="none">
                {translate('alert.refreshPage')}
              </Link>
            </>
          )}
        </Box>
        {Boolean(onRefresh && !showRefreshPage) && (
          <IconButton onClick={onClick}>
            <AutorenewIcon className={classes.refresh} />
          </IconButton>
        )}
      </Box>
    </Alert>
  )
}
